/* ==========================================================================
   REAL INVENTORY URGENCY ENGINE (Dawn threshold logic with variant updates)
   ========================================================================== */
(function () {

  function applyUrgency() {
    const textSpan = document.querySelector('[data-urgency-inventory]');
    const bar      = document.querySelector('[data-urgency-progress]');
    const dot      = document.querySelector('.urgency-dot');
    const track    = document.querySelector('.urgency-progress-container');

    if (!textSpan || !bar) return;

    const mgmt       = textSpan.getAttribute('data-inventory-management');
    const policy     = textSpan.getAttribute('data-inventory-policy');
    const qty        = parseInt(textSpan.getAttribute('data-inventory-quantity'), 10) || 0;
    const threshold  = parseInt(textSpan.getAttribute('data-inventory-threshold'), 10) || 10;
    const showQty    = textSpan.getAttribute('data-show-quantity') === 'true';

    if (mgmt !== 'shopify') {
      textSpan.closest('.urgency-inventory-wrapper').style.display = 'none';
      return;
    }
    textSpan.closest('.urgency-inventory-wrapper').style.display = '';

    if (track) track.style.setProperty('display', 'block', 'important');

    if (qty > 0) {

      if (qty <= threshold) {
        // LOW STOCK -> red (<=3) ya amber (4 to threshold)
        const color = qty <= 3 ? '#e53e3e' : '#d97706';
        const label = showQty ? `Only ${qty} left in stock` : 'Low stock';

        textSpan.textContent = label;
        textSpan.style.setProperty('color', color, 'important');
        if (dot) dot.style.setProperty('background-color', color, 'important');

        const fillPercent = Math.min((qty / threshold) * 100, 100);
        bar.style.setProperty('width', fillPercent + '%', 'important');
        bar.style.setProperty('background-color', color, 'important');

      } else {
        // IN STOCK (above threshold) -> green
        const color = '#16a34a';
        const label = showQty ? `${qty} in stock` : 'In stock';

        textSpan.textContent = label;
        textSpan.style.setProperty('color', color, 'important');
        if (dot) dot.style.setProperty('background-color', color, 'important');

        bar.style.setProperty('width', '100%', 'important');
        bar.style.setProperty('background-color', color, 'important');
      }

    } else {
      // qty === 0
      if (policy === 'continue') {
        const color = '#16a34a';
        textSpan.textContent = 'In stock';
        textSpan.style.setProperty('color', color, 'important');
        if (dot) dot.style.setProperty('background-color', color, 'important');
        bar.style.setProperty('width', '100%', 'important');
        bar.style.setProperty('background-color', color, 'important');

      } else {
        textSpan.textContent = 'Out of stock';
        textSpan.style.setProperty('color', '#9ca3af', 'important');
        if (dot) dot.style.setProperty('background-color', '#9ca3af', 'important');
        bar.style.setProperty('width', '0%', 'important');
        bar.style.setProperty('background-color', 'transparent', 'important');
      }
    }
  }

  // --- Variant change: update data attributes then re-run ---
  function updateVariantAttributes(variantId, available) {
    const textSpan = document.querySelector('[data-urgency-inventory]');
    if (!textSpan) return;

    textSpan.setAttribute('data-variant-id', variantId);
    textSpan.setAttribute('data-available', available ? 'true' : 'false');

    fetch(`/variants/${variantId}.js`)
      .then(r => r.json())
      .then(variant => {
        textSpan.setAttribute('data-inventory-management', variant.inventory_management || '');
        textSpan.setAttribute('data-inventory-quantity',   variant.inventory_quantity ?? 0);
        textSpan.setAttribute('data-inventory-policy',     variant.inventory_policy || 'deny');
        applyUrgency();
      })
      .catch(() => applyUrgency());
  }

  // Method A: Dawn standard variant:change event
  document.addEventListener('variant:change', function (e) {
    const variant = e.detail?.variant;
    if (variant) updateVariantAttributes(variant.id, variant.available);
  });

  // Method A2: Native variant-radios/variant-selects change (fallback agar variant:change na fire ho)
  document.addEventListener('change', function (e) {
    const variantPicker = e.target.closest('variant-radios, variant-selects, variant-picker, fieldset[name]');
    if (!variantPicker) return;

    setTimeout(function () {
      const variantId = new URLSearchParams(window.location.search).get('variant');
      if (variantId) updateVariantAttributes(variantId, true);
    }, 150);
  });

  // Method B: MutationObserver + URL fallback (DOM replace hone par bhi pakdega)
  const observer = new MutationObserver(function () {
    const urlParams      = new URLSearchParams(window.location.search);
    const variantIdUrl   = urlParams.get('variant');
    const textSpan       = document.querySelector('[data-urgency-inventory]');

    if (textSpan && variantIdUrl && textSpan.getAttribute('data-variant-id') !== variantIdUrl) {
      const form         = document.querySelector('form[action*="/cart/add"]');
      let isAvailable    = true;

      if (form) {
        const btn = form.querySelector('[name="add"]');
        if (btn && (btn.disabled || /sold out|out of stock/i.test(btn.textContent))) {
          isAvailable = false;
        }
      }
      updateVariantAttributes(variantIdUrl, isAvailable);
    } else if (textSpan && !textSpan.hasAttribute('data-listener-attached')) {
      // Naya span DOM mein aaya (Dawn ne section re-render kiya) -> turant current state apply karo
      textSpan.setAttribute('data-listener-attached', 'true');
      applyUrgency();
    }
  });

  // Init
  function init() {
    applyUrgency();
    const target = document.querySelector('body');
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  document.addEventListener('shopify:block:select', applyUrgency);
  document.addEventListener('shopify:section:load', applyUrgency);

})();